import {
  classeColorePerc,
  convertiData,
  convertiDataHM,
  monFetch,
} from "../../inc/inc";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import ElemGraficoPDF from "../../elementi/ElemGraficoPDF";
import ElemGraficoPDFTotal from "../../elementi/ElemGraficoPDFTotal";

import ReactApexChart from "react-apexcharts";

const Comp = (props) => {
  let params = useParams();

  let id = params.id;
  let tipo = params.tipo;
  let token = params.token;
  let idSezione = params.idSezione;

  const [questionario, setQuestionario] = useState({});
  const [domande, setDomande] = useState([]);
  const [grafici, setGrafici] = useState([]);
  const [totaleGrafico, setTotaleGrafico] = useState(0);

  const [grafRiepSerie, setGrafRiepSerie] = useState([]);

  const [grafRiepOptions, setGrafRiepOptions] = useState({});

  const [tipoCliente, setTipoCliente] = useState("");
  const [descCliente, setDescCliente] = useState("");

  const [ok, setOk] = useState(false);

  async function query() {
    const checkToken = await monFetch("/userGetFromToken", {
      token: token,
    });

    if (checkToken.success) {
      setOk(true);
    } else {
      return;
    }
    ////query grafici
    const resGraph = await monFetch("/surveyGetChartDataPdf", {
      survey_id: id,
    });
    setGrafici(resGraph.data);

    let tempCLi = "";
    let tempDesc = "";

    if (resGraph.totalScore <= 50) {
      tempCLi = "PRINCIPIANTE";
      tempDesc =
        "(scarsamente consapevole dei rischi cyber e senza misure di protezione)";
    } else if (resGraph.totalScore <= 75) {
      tempCLi = "INFORMATA";
      tempDesc =
        "(non del tutto consapevole sia dei rischi che degli strumenti, utilizza inoltre un approccio famigliare)";
    } else if (resGraph.totalScore <= 90) {
      tempCLi = "CONSAPEVOLE";
      tempDesc =
        " (comprende le implicazioni dei rischi cyber, ma la capacità operativa spesso presenta limiti per mettere in campo le corrette leve di attuazione)";
    } else {
      tempCLi = "MATURA";
      tempDesc =
        " (adotta un approccio strategico, consapevole dei rischi e sa attuare iniziative che coinvolgono persone, processi e tecnologie)";
    }

    setTipoCliente(tempCLi);
    setDescCliente(tempDesc);

    setTotaleGrafico(resGraph.totalScore);

    //grafico riepilogo
    let conteggioDati = 0;
    let margin = 3;
    let offsetTop = 0;

    let temp = [];
    let colori = [];
    let labels = [];
    resGraph.data.forEach((el, index) => {
      if (el.conforme) {
        temp.push(el.percentComp);
        colori.push(el.color);
        labels.push(el.sectionName);
        conteggioDati++;
      }
    });

    if (conteggioDati == 1) {
      margin = 15;
      offsetTop = 90;
    }

    if (conteggioDati == 2) {
      margin = 15;
      offsetTop = 60;
    }

    if (conteggioDati == 3) {
      margin = 12;
      offsetTop = 40;
    }
    if (conteggioDati == 4) {
      margin = 8;
      offsetTop = 30;
    }
    if (conteggioDati == 5) {
      margin = 5;
      offsetTop = 25;
    }

    let options = {
      // chart: {
      //   height: 700,
      //   type: "radialBar",
      // },
      plotOptions: {
        radialBar: {
          offsetY: 0,
          startAngle: 0,
          endAngle: 270,
          hollow: {
            margin: 5,
            size: "30%",
            background: "transparent",
            image: undefined,
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: false,
            },
          },
          track: {
            background: "#dbdbdb",
          },
        },
      },
      colors: colori,
      labels: labels,
      legend: {
        show: true,
        floating: true,
        fontSize: "14px",
        position: "right",
        offsetX: 400,
        offsetY: offsetTop,
        labels: {
          useSeriesColors: false,
        },
        markers: {
          size: 0,
        },
        formatter: function (seriesName, opts) {
          return (
            seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "%"
          );
        },
        itemMargin: {
          vertical: margin,
        },
      },
    };

    setGrafRiepOptions(options);

    setGrafRiepSerie(temp);

    // const resGraphTotal = await monFetch("/surveyGetChartTotalPdf", {
    //   survey_id: id,
    // });
    // setGraficoRiepilogo(resGraphTotal.data);

    ////query domande e dati generici
    const res = await monFetch("/surveyGetQuestionListPdf", {
      survey_id: id,
      idSezione: idSezione,
    });
    let tempDom = res.question;

    // console.log(tempDom);

    setQuestionario(res.survey);
    setDomande(tempDom);
  }

  useEffect(() => {
    // if (domande.length > 0) {
    //   // console.log(document.documentElement.innerHTML)
    //   //   let paged = new Previewer();
    //   //   let flow = paged
    //   //     .preview(window.DOMContent, ["/style_print.css"], document.body)
    //   //     .then((flow) => {
    //   //       // console.log("Rendered", flow.total, "pages.");
    //   //       window.print();
    //   //     });
    //   // }
    //   // // props.setTestoTitolo(
    //   // //   props.nuovo ? "Aggiungi Questionario" : "Modifica Questionario"
    //   // // );
    //   // //query delle domande del questionario
    // } else {
    query();
    // }
  }, []);

  useEffect(() => {
    //disabilita tasto destro
    // document.addEventListener("contextmenu", (event) => event.preventDefault());
  }, []);

  // let sottoSezioni = [
  //   "Sotto Sezione 1",
  //   "Sotto Sezione 2",
  //   "Sotto Sezione 3",
  //   "Sotto Sezione 4",
  //   "Sotto Sezione 5",
  //   "Sotto Sezione 6",
  // ];
  if (!ok) {
    return <div>No Auth</div>;
  }
  return (
    <div className="pdfContent">
      <div className="wrapCopertinaPDF">
        <div className="copertinaPDF">
          <div className="fasciaImg">
            <img src={process.env.PUBLIC_URL + "/img/PSS.png"} alt="PSS"></img>
          </div>
        </div>
        <div className="sottoCopertina">
          <h2 style={{ marginLeft: 35 }}>
            Fase 1: <small>IT Risk Assessment</small>
            <br />
            Cliente: <small>{questionario.businessName}</small>
          </h2>
          <div style={{ padding: "10px 35px 10px 10px" }}>
            <b className="maiuscF">Asset inclusi:</b>
            {grafici.map((graf, index) => {
              return (
                <p style={{ margin: "0" }} key={index}>
                  {graf.sectionName}
                </p>
              );
            })}
          </div>
        </div>
      </div>

      <div className="titoloPDF">
        <h1>Report assets IT</h1>
        <h2>Analisi rischi IT</h2>
      </div>

      <div className="bloccoAnagPdf">
        <div className="sx">Ragione sociale</div>
        <div className="dx">
          <b>{questionario.businessName}</b>
        </div>
      </div>
      <div className="bloccoAnagPdf">
        <div className="sx">Data somministrazione</div>
        <div className="dx">{convertiData(questionario.date)}</div>
      </div>
      <div className="bloccoAnagPdf">
        <div className="sx">Responsabile del contratto</div>
        <div className="dx">{questionario.responsabile}</div>
      </div>
      <div className="bloccoAnagPdf">
        <div className="sx">Telefono</div>
        <div className="dx">{questionario.tel}</div>
      </div>
      <div className="bloccoAnagPdf">
        <div className="sx">Mail</div>
        <div className="dx">{questionario.email}</div>
      </div>
      <div className="bloccoAnagPdf">
        <div className="sx">Partita IVA</div>
        <div className="dx">{questionario.piva}</div>
      </div>
      <div className="bloccoAnagPdf">
        <div className="sx">Codice fiscale</div>
        <div className="dx">{questionario.cf}</div>
      </div>
      <div className="bloccoAnagPdf">
        <div className="sx">Indirizzo</div>
        <div className="dx">
          {questionario.address +
            ", " +
            questionario.city +
            " (" +
            questionario.state +
            ")"}
        </div>
      </div>
      <div className="bloccoAnagPdf">
        <div className="sx">Revisione</div>
        <div className="dx">{questionario.review}</div>
      </div>
      <div className="bloccoAnagPdf">
        <div className="sx">Versione</div>
        <div className="dx">
          {convertiDataHM(questionario.version * 1000)} | Cod.{" "}
          {questionario.version}
        </div>
      </div>

      <div className="bloccoSfondoPdf breakAfter">
        Il presente documento ed il suo contenuto è da ritenersi{" "}
        <strong>altamente riservato</strong>. Se ne consiglia l'archiviazione
        secondo le proprie direttive aziendali. In ottemperanza al decreto
        legislativo 196 del 2003 e del regolamento UE 679 del 2016 sulla tutela
        dei dati personali si informa il cliente che, in questo documento,
        potrebbero essere contenute informazioni strettamente confidenziali,
        dati personali, informazioni (anche parziali) su dispositivi elettronici
        ed informazioni sulla configurazione delle misure di sicurezza
        informatica che potrebbero essere sfruttate da malintenzionati per
        ledere alla sicurezza e alla riservatezza dei dati aziendali. Per
        informazioni riguardanti le politiche adottate in termini di trattamento
        dati personali da parte di Sinattica Srl visitare la pagina{" "}
        <a href="https://sinattica.com/privacy-policy">
          https://sinattica.com/privacy-policy
        </a>
        .
        <br />
        Dopo l'avvenuta consegna del suddetto documento (al cliente), in caso di
        divulgazione, anche parziale, di informazioni in esso contenute
        Sinattica Srl non può e potrà in alcun modo essere ritenuta
        responsabile.
        <br />
        Questo documento, comprese le logiche di risultato, è protetto dalle
        vigenti norme sulla proprietà intellettuale. La trasformazione,
        l'adattamento totale o parziale, la riproduzione o trasmissione in
        qualsiasi forma e/o con qualsiasi mezzo elettronico, meccanico o altro
        (compresi i microfilm, le fotocopie), nonchè la memorizzazione anche
        digitale su supporti di qualsiasi tipo (inclusi magnetici o ottici), i
        diritti di noleggio e di prestito, sono riservati in tutti i paesi. Non
        è consentita qualsivoglia duplicazione, distribuzione, cessione anche
        parziale del presente documento a meno di esplicita autorizzazione
        scritta in accordo con Sinattica Srl.
        <hr />
        Per le logiche di valutazione e punteggi, statistiche, euristica,
        risposte, Sinattica Srl potrebbe essersi avvalsa di tecnologie
        supportate da intelligenza artificiale.
      </div>

      <div className="boxPDF" style={{ paddingBottom: 0 }}>
        <Grid container spacing={2} className="breakAfter">
          <Grid item xs={12} className="breakAfter">
            <div className="testo1Pdf">
              <p>
                Il rischio IT, essendo una componente integrante della gestione
                del rischio aziendale, richiede un'attenta valutazione di
                diversi elementi che spesso operano in settori separati
                all'interno di un'organizzazione.
              </p>
              <p>
                Perché la gestione del rischio informatico è così insidiosa?
              </p>
              <p>
                Il rischio IT è per sua natura fluido; varia in base al contesto
                aziendale e agli standard di riferimento. Ad esempio, il
                phishing, sebbene sia un rischio IT, in alcuni contesti, come
                quello bancario, può essere considerato un rischio di frode.{" "}
              </p>
              <p>
                {" "}
                L’integrazione multidisciplinare risulta dunque necessaria tra
                le funzioni IT, le funzioni operative e di business, e il risk
                management. Questa integrazione può essere complicata a causa
                delle diverse prospettive e conoscenze di queste funzioni.
              </p>
              <p>
                {" "}
                I rischi IT possono avere un impatto significativo su diversi
                livelli operativi e strategici dell'azienda, rendendo cruciale
                una valutazione accurata e integrata.{" "}
              </p>
              <p>
                Un approccio pragmatico e flessibile è fondamentale per gestire
                efficacemente questi rischi, con un occhio costante alle
                specificità contestuali dell'organizzazione.{" "}
              </p>
              <p>
                Per definire ed attuare un piano di protezione a lungo termine,
                è fondamentale avere una visione chiara dei rischi a cui
                l’infrastruttura informatica è esposta così come l’esposizione
                dei dati informatici in generale. A tale scopo, la FASE 1 del
                nostro PSS (Progetto Sicurezza Sinattica).
              </p>
              <h3>FASI OPERATIVE:</h3>
              <ol>
                <li>Analisi dei processi di gestione dei dati:</li>
                <ol type="a">
                  <li>
                    <b>Identificazione degli stakeholder e degli owner:</b> È
                    essenziale individuare chi ha la responsabilità dei rischi
                    IT. L'owner ideale dovrebbe avere una comprensione completa
                    sia degli aspetti tecnici sia delle implicazioni aziendali
                    dei rischi.
                  </li>
                  <li>
                    <b>Definizione del perimetro dell’assessment:</b> Il
                    perimetro deve essere stabilito in funzione delle finalità
                    specifiche dell'assessment. Può variare da un focus sui
                    processi aziendali a uno più mirato sulle tecnologie
                    specifiche.{" "}
                  </li>
                </ol>
                <li>Identificazione dei rischi informatici:</li>{" "}
                <ol type="a">
                  <li>
                    <b>Mappatura dei rischi informatici:</b> Questa fase
                    richiede una conoscenza approfondita sia delle metodologie
                    IT che del contesto aziendale specifico. L'obiettivo è
                    identificare minacce e vulnerabilità pertinenti.{" "}
                  </li>
                  <li>
                    {" "}
                    <b> Misurazione dei rischi informatici:</b> Si stima la
                    probabilità e l'impatto degli eventi di rischio,
                    considerando sia le informazioni interne (storico degli
                    incidenti, stato dei controlli) sia quelle esterne (eventi
                    simili in altre aziende).{" "}
                  </li>
                  <li>
                    {" "}
                    <b>Valutazione dei rischi informatici:</b> Confrontare i
                    risultati della misurazione con la propensione al rischio
                    dell'azienda. Un approccio qualitativo può aiutare a
                    semplificare il processo decisionale.{" "}
                  </li>
                  <li>
                    <b>Gestione dei Rischi Informatici:</b> In questa fase, si
                    decide come rispondere ai rischi identificati, scegliendo
                    tra mitigazione, trasferimento, accettazione o eliminazione
                    del rischio.{" "}
                  </li>
                </ol>
                <li> Qualificazione dei rischi identificati:</li>{" "}
                <ol type="a">
                  <li>
                    <b>Rappresentazione dei rischi informatici:</b> Rendere i
                    rischi comprensibili al management e agli stakeholder
                    richiede una presentazione chiara e non troppo tecnica dei
                    rischi, evidenziando la loro rilevanza nel contesto
                    aziendale complessivo.
                  </li>
                  <li>
                    <b>Monitoraggio dei rischi informatici:</b> Questa fase
                    prevede la raccolta di dati continui e la loro traduzione in
                    indicatori significativi. È importante assicurare che questi
                    indicatori siano implementati effettivamente e non rimangano
                    solo teorici.
                  </li>
                </ol>
              </ol>
              <p>
                Il risultato <i>“ready to”</i> consultabile nelle pagine
                successive di questo documento è sfrutto delle nostre esperienze
                professionali e competenze nell’ambito IT che grazie alle 3 FASI
                OPERATIVE aventi come riferimento framework standardizzati quali
                ISO 27001, NIST (National Institute of Standards and
                Technology), direttive NIS2 (Network and Information System
                Security) ed il Regolamento generale sulla protezione dei dati
                GDPR (UE) 2016/679, ne semplificano la comprensione rendendola
                immediata sia nell’identificazione dei problemi rilevati, come
                pure suggerendo miglioramenti concreti da attuare.
              </p>
            </div>
          </Grid>
          {grafici.map((graf, index) => (
            <Grid
              item
              xs={12}
              key={index}
              className={index + 1 != grafici.length ? "graficoPDFBorder" : ""}
            >
              <ElemGraficoPDF
                colore={graf.color}
                nomeSezione={graf.sectionName}
                sottoSezioni={graf.subSections}
                percentualeOk={graf.percentComp}
                questionsTot={graf.questionsTot}
                rispTot={graf.rispTot}
                conforme={graf.conforme}
                // percentualeNo={graf.percentNotComp}
              />
            </Grid>
          ))}

          <Grid item xs={12} className="breakBefore">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "900px",
              }}
            >
              <div style={{ flexGrow: 0, marginTop: 0, marginBottom: 15 }}>
                <ElemGraficoPDFTotal
                  colore="#2c57a4"
                  nomeSezione="Riepilogo"
                  percentualeOk={totaleGrafico}
                  // percentualeNo={graficoRiepilogo.percentNotComp}
                />
              </div>

              <div>
                {/* riepiloghi piccoli */}
                {/* {grafici.map((graf, index) => (
                  <ElemGraficoPDFSmall
                    colore={graf.color}
                    nomeSezione={graf.sectionName}
                    percentualeOk={graf.percentComp}
                  />
                ))} */}
                <p
                  style={{
                    textAlign: "justify",
                    padding: "0 15px 0px",
                    marginBottom: 6,
                    marginTop: 0,
                  }}
                >
                  Commisurando il nostro risultato con i dati forniti dal{" "}
                  <b>
                    <i>Cyber Index PMI</i>
                  </b>{" "}
                  abbiamo classificato la tua impresa come <br />
                  <span style={{ textAlign: "center", display: "block" }}>
                    <b>
                      <i>
                        <u>{tipoCliente}</u>
                      </i>
                    </b>
                  </span>
                  <i>
                    <small style={{ paddingLeft: 10, display: "block" }}>
                      <b>Matura</b> - ha adottato un approccio strategico,
                      consapevole dei rischi cyber e sa attuare iniziative che
                      coinvolgono persone, processi e tecnologie.
                      <br />
                      <b>Consapevole</b> - comprende le implicazioni dei rischi
                      cyber, ma la capacità operativa mostra limiti
                      nell'attuazione delle corrette leve.
                      <br />
                      <b>Informata</b> - non del tutto consapevole sia dei
                      rischi che degli strumenti, inoltre ha approccio
                      famigliare.
                      <br />
                      <b>Principiante</b> - scarsamente consapevole dei rischi
                      cyber e senza misure di protezione.{" "}
                    </small>
                    <br />
                    Cos’è <b>Cyber Index Pmi</b>:
                    <br /> È il rapporto che fotografa lo stato di
                    consapevolezza sulla cyber security tra le piccole e medie
                    imprese italiane. l'indice nazionale previsto dalla
                    Strategia Nazionale di Cybersicurezza, che andrà ad
                    alimentare il Cyber Index europeo.
                    <br />
                    Nasce dall’accordo tra Confindustria, Agenzia per la
                    Cybersicurezza Nazionale e Generali e sarà sviluppato con il
                    contributo dell’Osservatorio Cybersecurity & Data Protection
                    della School of Management del Politecnico di Milano,
                    partner scientifico dell’iniziativa.
                  </i>
                  {/* Il nostro algoritmo, basandosi sull'esperienza della nostra
                  azienda e sui dati forniti dal Cyber Security Index 2023 ha
                  classificato la tua impresa come un{" "}
                  <b>cliente {tipoCliente} </b> {descCliente} */}
                </p>
                <p
                  style={{
                    textAlign: "justify",
                    padding: "0 15px 0",
                    marginTop: 0,
                    marginBottom: 0,
                  }}
                >
                  <i>
                    <small>
                      <b>Note:</b> <br />
                      Il nostro algoritmo confronta casistiche, statistiche
                      anonimizzate e aggregate generando per ogni singola
                      risposta un coefficiente chiamato "peso".
                      <br />
                      Il modello attribuisce alle singole risposte dei singoli
                      assets conformi il peso ponderato medio.
                      <br />
                      Il peso ponderato medio contribuisce, in ogni asset, alla
                      definizione della scala di gravità visualizzata nel range
                      0-100.
                      <br />
                      La media di ogni singolo asset conforme, contribuisce a
                      definire la media totale del presente report.
                    </small>
                  </i>
                </p>
              </div>
              <div id="chart" style={{ width: "100%", marginTop: 0 }}>
                <ReactApexChart
                  options={grafRiepOptions}
                  series={grafRiepSerie}
                  type="radialBar"
                  height={550}
                />
              </div>
            </div>
          </Grid>

          <Grid item xs={12} className="breakBefore">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "900px",
              }}
            >
              <div style={{ flexGrow: 0, marginTop: 0, marginBottom: 15 }}>
                <div className="legenda">
                  <h3 style={{ width: "100%", margin: 0 }}>
                    Legenda colori risposte:
                  </h3>
                  <div>
                    <div className="leg grav1"></div>
                    <div className="testo">Grave</div>
                  </div>
                  <div>
                    <div className="leg grav3"></div>
                    <div className="testo">Migliorabile</div>
                  </div>
                  <div>
                    <div className="leg grav0"></div>
                    <div className="testo">Neutro</div>
                  </div>
                  <div>
                    <div className="leg grav7"></div>
                    <div className="testo">Conforme</div>
                  </div>
                  <h4 style={{ width: "100%", margin: 0 }}>Spiegazione:</h4>
                  <ul>
                    <li>
                      <b>Grave:</b> da attenzionare il prima possibile e
                      attraverso le note correttive porre rimedio a quanto
                      richiesto nella domanda.
                      <br />
                    </li>
                    <li>
                      <b>Migliorabile:</b> analizzare la nota correttiva per
                      aumentare l’efficacia della misura descritta nella
                      domanda.
                      <br />
                    </li>
                    <li>
                      <b>Neutro:</b> la risposta è propedeutica al contesto e
                      non influisce sulla valutazione della specifica sezione
                      del questionario.
                      <br />
                    </li>
                    <li>
                      <b>Conforme:</b> non si necessità di correzioni
                      sull’argomento trattato nella domanda. <br />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      {domande.map((el1, index) => {
        console.log(el1, idSezione);
        if (idSezione && el1.section[2] != idSezione) {
          return null;
        }
        let title;
        return (
          <div key={index} className="domandePDF">
            {el1.subsection.map((el, index2) => {
              if (index2 == 0) {
                title = (
                  <>
                    <h2
                      className="breakBefore"
                      style={{
                        backgroundColor: el1.section[1],
                        // color: "white",
                      }}
                    >
                      {el1.section[0]}
                    </h2>{" "}
                    <h3>{el.name}</h3>
                  </>
                );
              } else {
                title = <h3>{el.name}</h3>;
              }

              return (
                <div key={index2}>
                  <div className="tabellaDomPdfBox">
                    <Table className="">
                      <colgroup>
                        <col style={{ width: "7%" }} />
                        <col style={{ width: "73%" }} />
                        <col style={{ width: "20%" }} />
                      </colgroup>
                      <TableBody>
                        <TableRow className="tableHead">
                          {/* titolo sottosezione */}
                          <TableCell colSpan={3}>{title}</TableCell>
                        </TableRow>
                        {el.questions.map((dom, indexDomanda) => {
                          if (dom.answer != null || idSezione) {
                            return (
                              <TableRow key={dom.id} className="rigaPDF">
                                <TableCell
                                  className="colNumero"
                                  style={{ width: "7%" }}
                                >
                                  {dom.order}
                                </TableCell>

                                <TableCell style={{ width: "73%" }}>
                                  <div
                                    className="testoDomandaPdf"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        "<b><span className='maiuscF'>D:</span> " +
                                        dom.textNoHtml +
                                        "</b>",
                                    }}
                                  ></div>

                                  {dom.Canswer_customer_note && (
                                    //note clienta risposta questionario
                                    <div
                                      className="noteCommercialePdf"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          "<b>Annot. Cliente: </b> <i>" +
                                          dom.Canswer_customer_note +
                                          "</i>",
                                      }}
                                    ></div>
                                  )}

                                  {tipo != "cli" &&
                                    dom.Canswer_internal_note && (
                                      // se non questionario cliente
                                      <div
                                        className="noteInternePdf"
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            "<b>Note intervistatore: </b>" +
                                            dom.Canswer_internal_note,
                                        }}
                                      ></div>
                                    )}

                                  {tipo != "cli" && dom.QInternalNote && (
                                    // se non questionario cliente
                                    //note interne domanda
                                    <div
                                      className="noteDomInternePdf"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          "<span class='maiuscF'>Spiegazioni: </span>" +
                                          dom.QInternalNote,
                                      }}
                                    ></div>
                                  )}

                                  {tipo == "com" && dom.QCommercialNote && (
                                    //se commerciale
                                    <div
                                      className="noteDomCommPdf"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          "<b>Note commerciali domanda: </b>" +
                                          dom.QCommercialNote,
                                      }}
                                    ></div>
                                  )}
                                  {tipo == "com" && dom.Ans_commercialNote && (
                                    //se commerciale
                                    <div
                                      className="noteRispCommPdf"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          "<b>Note commerciali risposta: </b>" +
                                          dom.Ans_commercialNote,
                                      }}
                                    ></div>
                                  )}
                                  {tipo == "com" && dom.Ans_commercialNote2 && (
                                    //se commerciale
                                    <div
                                      className="noteRispCommPdf"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          "<b>Note commerciali risposta: </b>" +
                                          dom.Ans_commercialNote2,
                                      }}
                                    ></div>
                                  )}
                                  {tipo == "com" && dom.Ans_commercialNote3 && (
                                    //se commerciale
                                    <div
                                      className="noteRispCommPdf"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          "<b>Note commerciali risposta: </b>" +
                                          dom.Ans_commercialNote3,
                                      }}
                                    ></div>
                                  )}
                                  {tipo == "com" && dom.Ans_commercialNote4 && (
                                    //se commerciale
                                    <div
                                      className="noteRispCommPdf"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          "<b>Note commerciali risposta: </b>" +
                                          dom.Ans_commercialNote4,
                                      }}
                                    ></div>
                                  )}
                                  {tipo == "com" && dom.Ans_commercialNote5 && (
                                    //se commerciale
                                    <div
                                      className="noteRispCommPdf"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          "<b>Note commerciali risposta: </b>" +
                                          dom.Ans_commercialNote5,
                                      }}
                                    ></div>
                                  )}

                                  {!idSezione && tipo != "cli" &&
                                    dom.Ans_internalNote &&
                                    classeColorePerc(dom.score, false) !==
                                      "grav7" && (
                                      // se non questionario cliente
                                      //note commerciale domanda
                                      <div
                                        className={
                                          "noteRispIntPdf " +
                                          classeColorePerc(dom.score, false) +
                                          "-text"
                                        }
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            (dom.answer2
                                              ? "<b>" +
                                                dom.answer +
                                                "</b><div style='padding-left:15px'>"
                                              : "") +
                                            "<span class='maiuscF'><b>Note correttive: </b></span> <i>" +
                                            dom.Ans_internalNote +
                                            "</i>" +
                                            (dom.answer2 ? "</div>" : ""),
                                        }}
                                      ></div>
                                    )}
                                  {!idSezione && tipo != "cli" &&
                                    dom.Ans_internalNote2 &&
                                    classeColorePerc(dom.score2, false) !==
                                      "grav7" && (
                                      // se non questionario cliente
                                      //note commerciale domanda
                                      <div
                                        className={
                                          "noteRispIntPdf " +
                                          classeColorePerc(dom.score2, false) +
                                          "-text"
                                        }
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            "<b>" +
                                            dom.answer2 +
                                            "</b><div style='padding-left:15px'>" +
                                            "<span class='maiuscF'><b>Note correttive: </b></span> <i>" +
                                            dom.Ans_internalNote2 +
                                            "</i></div>",
                                        }}
                                      ></div>
                                    )}
                                  {!idSezione && tipo != "cli" &&
                                    dom.Ans_internalNote3 &&
                                    classeColorePerc(dom.score3, false) !==
                                      "grav7" && (
                                      // se non questionario cliente
                                      //note commerciale domanda
                                      <div
                                        className={
                                          "noteRispIntPdf " +
                                          classeColorePerc(dom.score3, false) +
                                          "-text"
                                        }
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            "<b>" +
                                            dom.answer3 +
                                            "</b><div style='padding-left:15px'>" +
                                            "<span class='maiuscF'><b>Note correttive: </b></span> <i>" +
                                            dom.Ans_internalNote3 +
                                            "</i></div>",
                                        }}
                                      ></div>
                                    )}
                                  {!idSezione && tipo != "cli" &&
                                    dom.Ans_internalNote4 &&
                                    classeColorePerc(dom.score4, false) !==
                                      "grav7" && (
                                      // se non questionario cliente
                                      //note commerciale domanda
                                      <div
                                        className={
                                          "noteRispIntPdf " +
                                          classeColorePerc(dom.score4, false) +
                                          "-text"
                                        }
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            "<b>" +
                                            dom.answer4 +
                                            "</b><div style='padding-left:15px'>" +
                                            "<span class='maiuscF'><b>Note correttive: </b></span> <i>" +
                                            dom.Ans_internalNote4 +
                                            "</i></div>",
                                        }}
                                      ></div>
                                    )}
                                  {!idSezione && tipo != "cli" &&
                                    dom.Ans_internalNote5 &&
                                    classeColorePerc(dom.score5, false) !==
                                      "grav7" && (
                                      // se non questionario cliente
                                      //note commerciale domanda
                                      <div
                                        className={
                                          "noteRispIntPdf " +
                                          classeColorePerc(dom.score5, false) +
                                          "-text"
                                        }
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            "<b>" +
                                            dom.answer5 +
                                            "</b><div style='padding-left:15px'>" +
                                            "<span class='maiuscF'><b>Note correttive: </b></span> <i>" +
                                            dom.Ans_internalNote5 +
                                            "</i></div>",
                                        }}
                                      ></div>
                                    )}
                                </TableCell>
                                <TableCell
                                  className="cellaRispPDF"
                                  style={{
                                    width: "20%",
                                    textAlign: "center",
                                    position: "relative",
                                  }}
                                >
                                  {/* {indexDomanda == 0 && (
                                    <> */}
                                  <p
                                    style={{
                                      // position: "absolute",
                                      // top: 17,
                                      marginBottom: 10,
                                      fontSize: 11,
                                      fontWeight: "bold",
                                    }}
                                    className="maiuscF"
                                  >
                                    Risposta cliente:
                                  </p>
                                  {/* risposte --------------- */}
                                  {dom.answer != null && (
                                    <b
                                      className={classeColorePerc(
                                        dom.score,
                                        false
                                      )}
                                      style={{
                                        padding: "5px",
                                        borderRadius: 6,
                                        display: "block",
                                      }}
                                    >
                                      {dom.answer}
                                    </b>
                                  )}
                                  {dom.answer2 != null && (
                                    <b
                                      className={classeColorePerc(
                                        dom.score2,
                                        false
                                      )}
                                      style={{
                                        padding: "5px",
                                        borderRadius: 6,
                                        display: "block",
                                        marginTop: 5,
                                      }}
                                    >
                                      {dom.answer2}
                                    </b>
                                  )}
                                  {dom.answer3 != null && (
                                    <b
                                      className={classeColorePerc(
                                        dom.score3,
                                        false
                                      )}
                                      style={{
                                        padding: "5px",
                                        borderRadius: 6,
                                        display: "block",
                                        marginTop: 5,
                                      }}
                                    >
                                      {dom.answer3}
                                    </b>
                                  )}
                                  {dom.answer4 != null && (
                                    <b
                                      className={classeColorePerc(
                                        dom.score4,
                                        false
                                      )}
                                      style={{
                                        padding: "5px",
                                        borderRadius: 6,
                                        display: "block",
                                        marginTop: 5,
                                      }}
                                    >
                                      {dom.answer4}
                                    </b>
                                  )}
                                  {dom.answer5 != null && (
                                    <b
                                      className={classeColorePerc(
                                        dom.score5,
                                        false
                                      )}
                                      style={{
                                        padding: "5px",
                                        borderRadius: 6,
                                        display: "block",
                                        marginTop: 5,
                                      }}
                                    >
                                      {dom.answer5}
                                    </b>
                                  )}

                                  {idSezione &&
                                    dom.possibleAnswers &&
                                    dom.possibleAnswers.length > 0 && (
                                      <>
                                        <br />
                                        <b style={{ fontSize: 11 }}>
                                          Risposte possibili:
                                        </b>
                                        <ul
                                          style={{ margin: 0, paddingLeft: 15 }}
                                        >
                                          {dom.possibleAnswers.map(
                                            (ans, index) => (
                                              <li
                                                key={index}
                                                style={{
                                                  textAlign: "left",
                                                  fontSize: 11,
                                                }}
                                              >
                                                {ans.text}
                                              </li>
                                            )
                                          )}
                                        </ul>
                                      </>
                                    )}
                                </TableCell>
                              </TableRow>
                            );
                          } else {
                            return "";
                          }
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
      <div className="wrapCopertinaChiusuraPDF breakBefore">
        <div className="copertinaChiusuraPDF">
          <img src={process.env.PUBLIC_URL + "/img/PSSwhite.png"}></img>
        </div>
      </div>
    </div>
  );
};

export default Comp;
